// Supermove
import {useDebouncedCallback, useEffect} from '@supermove/hooks';

// Shared
import {ChannelType, SSEEventType, SSEEventTypes} from '@shared/modules/SSE/interfaces';
import {useSSEv2} from '@shared/modules/SSE/v2/hooks/useSSEv2';

const useEventListenerForProject = ({
  projectId,
  handleEvent,
  eventTypes = [SSEEventType.COMMUNICATION_NEW],
  delay = 1000,
  isDisabled = false,
}: {
  projectId: string;
  handleEvent: (eventType?: SSEEventTypes) => void;
  eventTypes?: SSEEventTypes[];
  delay?: number;
  isDisabled?: boolean;
}) => {
  const {latestEvent, setChannelFilters} = useSSEv2(eventTypes, []);
  const debouncedHandleEvent = useDebouncedCallback(handleEvent, delay);

  // Setup listener for project events
  useEffect(() => {
    if (!isDisabled) {
      setChannelFilters([
        {
          channelId: projectId,
          channelType: ChannelType.PROJECT,
        },
      ]);
    }
    return () => setChannelFilters([]);
  }, [projectId, isDisabled]);

  // Handle the latest event
  useEffect(() => {
    if (latestEvent) {
      debouncedHandleEvent(latestEvent?.eventType);
    }
  }, [latestEvent]);
};

export default useEventListenerForProject;
